import { useMemo } from 'react'

import moment from 'moment'

import type { TimeSlot } from 'modules/shift_management/components/ShiftManagement/TimeGridTable/types'
import { Result } from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/TimeOffRow/useGetTimeOffRow'

interface UseBuildTimeOffSummaryOptions {
  shouldShow: boolean
  slots: TimeSlot[]
  entityId: string
  data: Result
  onOpenSidepanel: (date: moment.Moment) => void
}

export interface TimeOffSummaryOptions {
  slots: TimeSlot[]
  entityId: string
  loading: boolean
  getAbsencesCountAt: (date: Date) => number
  getPublishedRestDaysCountAt: (date: Date) => number
  onClick: (date: Date) => void
}

const useBuildTimeOffSummary = ({
  shouldShow,
  slots,
  entityId,
  data,
  onOpenSidepanel,
}: UseBuildTimeOffSummaryOptions): TimeOffSummaryOptions | undefined => {
  return useMemo(() => {
    if (!shouldShow) return undefined

    return {
      slots,
      entityId,
      loading: data.loading,
      getAbsencesCountAt: (date: Date) => data.leaves?.filterByDate(moment(date))?.length ?? 0,
      getPublishedRestDaysCountAt: (date: Date) => {
        return (
          data.restDays?.filterByDate(moment(date))?.filter((restDay) => restDay.isPublished)
            .length ?? 0
        )
      },
      onClick: (date: Date) => onOpenSidepanel(moment(date)),
    }
  }, [data.leaves, data.loading, data.restDays, entityId, onOpenSidepanel, shouldShow, slots])
}

export { useBuildTimeOffSummary }
